<section class='container my-4'>
  <div class='d-flex flex-column justify-content-center'>
   <img class='my-2 my-lg-4' src='assets/img/404.svg' alt='Error 404 pagina no encontrada' id='imgError'>
   <h4 class='text-center'>Lo sentimos, no hemos podido encontrar la página que buscas.</h4>
   <div class='border my-4 p-2'>
    <p>¿Qué puedo hacer?</p>
    <a class='noLink' [href]='""'>Volver al inicio</a>
     <br>
    <a class='noLink' [href]='"cotiza"'>Cotizar póliza</a>
   </div>   
  </div>
</section>
